import ApiFetcher from "../utils/ApiFetcher";
import { put, call } from "redux-saga/effects";
import { makeQueryString } from "../utils/urls";
import {
  sagaListSuccess,
  sagaOneSuccess,
  sagaSearchSuccess,
  sagaCreateSuccess,
  sagaUpdateSuccess,
  sagaDeleteSuccess
} from "../actions/ActionTypes";
import { showSuccessMsg, showErrorMsg } from "../actions";

const MEMBERS = "MEMBERS";
const MEMBER = "MEMBER";
const apiFetcher = new ApiFetcher();
export function* fetchMembers(action) {
  let queryString = makeQueryString(action.data);
  try {
    const res = yield call(apiFetcher.findAll, `members?${queryString}`);
    yield put({
      type: sagaListSuccess(MEMBERS),
      data: res.data
    });
  } catch (e) {}
}

export function* searchMembers(action) {
  let queryString = makeQueryString(action.data);
  try {
    const res = yield call(apiFetcher.findAll, `members?${queryString}`);
    yield put({
      type: sagaSearchSuccess(MEMBERS),
      data: res.data
    });
  } catch (e) {}
}

export function* fetchMember(action) {
  try {
    const res = yield call(apiFetcher.find, "members", action.id);
    yield put({
      type: sagaOneSuccess(MEMBER),
      data: res.data
    });
  } catch (e) {}
}

export function* createMember(action) {
  try {
    const res = yield call(apiFetcher.create, "members", action.data);

    yield put({
      type: sagaCreateSuccess(MEMBER),
      data: res.data
    });
    if (res.data.success) {
      yield put(showSuccessMsg("Member created successfully"));
    } else {
      yield put(
        showErrorMsg(
          "Sorry, errors were encountered whilst trying to save the data."
        )
      );
    }
  } catch (e) {}
}

export function* updateMember(action) {
  //restore old data to form when save fails -> probably in reducer
  try {
    const res = yield call(
      apiFetcher.update,
      "members",
      action.data,
      action.id
    );
    yield put({
      type: sagaUpdateSuccess(MEMBER),
      data: res.data
    });
    if (res.data.success) {
      yield put(showSuccessMsg("Member details updated successfully"));
    } else {
      yield put(
        showErrorMsg(
          "Sorry, errors were encountered whilst trying to save the data."
        )
      );
    }
  } catch (e) {}
}


export function* deleteMember(action) {
  try {
    const res = yield call(
      apiFetcher.makeRequest,
      "DELETE",
      `/api/members/${action.data.id}`,
      action.data
    );

    if (res.data.success) {
      yield put(showSuccessMsg("Member deleted successfully"));
      yield put({
        type: sagaDeleteSuccess(MEMBER),
        data: {id: action.data.id}
      });
    } else {
      yield put(
        showErrorMsg(
          "Sorry, errors were encountered whilst trying to delete member."
        )
      );
    }
  } catch (e) {}
}


// WEBPACK FOOTER //
// ./src/sagas/members.js